import styles from "@/components/pages/key-bpm-finder/components/styles/key-bpm-finder-file-card.module.scss";
import { FinderFile } from "@/components/pages/key-bpm-finder/hooks/use-key-bpm-finder";
import SmallLoader from "@/components/common/small-loader";
import KeyBpmFinderPlayer from "@/components/pages/key-bpm-finder/components/key-bpm-finder-player";
import { MutableRefObject } from "react";
import tooltipStyles from "@/components/common/styles/tooltip.module.scss";
import { Tooltip } from "react-tooltip";

type FileCardProps = {
  finderFile: FinderFile;
  handlePlayTrack: (
    playerRef: MutableRefObject<HTMLAudioElement>,
  ) => Promise<void>;
  isPlayerActive: (playerRef: MutableRefObject<HTMLAudioElement>) => boolean;
};

const KeyBpmFinderFileCard = ({
  finderFile,
  handlePlayTrack,
  isPlayerActive,
}: FileCardProps) => {
  return (
    <div className={styles.wrapper}>
      <div
        className={styles.file_name}
        data-tooltip-id="fileNameTooltip"
        data-tooltip-content={finderFile.file.name}
      >
        {finderFile.file.name}
        <Tooltip
          className={tooltipStyles.tooltip}
          id="fileNameTooltip"
          place="top"
        />
      </div>
      <div className={styles.key_bpm_wrapper}>
        <div className={styles.key_value_wrapper}>
          <div className={styles.secondary_text}>Key</div>
          {finderFile.key ? (
            <div className={styles.text}>{finderFile.key}</div>
          ) : (
            <SmallLoader size={"18px"} />
          )}
        </div>
        <div className={styles.key_value_wrapper}>
          <div className={styles.secondary_text}>BPM</div>
          {finderFile.bpm ? (
            <div className={styles.text}>{finderFile.bpm}</div>
          ) : (
            <SmallLoader size={"18px"} />
          )}
        </div>
      </div>
      <div className={styles.player_wrapper}>
        <KeyBpmFinderPlayer
          trackUrl={finderFile.url}
          handlePlayTrack={handlePlayTrack}
          isPlayerActive={isPlayerActive}
        />
      </div>
    </div>
  );
};

export default KeyBpmFinderFileCard;
